import { __assign } from "tslib";
import React, { Fragment } from 'react';
import { IconSVG } from '../icon-svg/icon-svg';
export var IconArrowRight = function (SVGprops) {
    return (React.createElement(IconSVG, __assign({}, SVGprops),
        React.createElement(Fragment, null,
            React.createElement("path", { d: "M14.71 6.29004L13.29 7.71004L16.59 11H3V13H16.59L13.29 16.29L14.71 17.71L20.41 12L14.71 6.29004Z" }))));
};
